import React, { useState, useRef, useEffect } from "react";
import {
  usePhoneInput,
  defaultCountries,
  parseCountry,
  FlagImage,
} from "react-international-phone";
import "react-international-phone/style.css";
import "./style.css";
import { getCountryName } from "../../utils/countryNamesPtBR";

const LoginPhoneInput = ({
  value = "",
  onChange,
  placeholder = "",
  required = false,
  autoComplete = "off",
  ...rest
}) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchTimeout, setSearchTimeout] = useState(null);
  const menuRef = useRef(null);

  const phoneInput = usePhoneInput({
    defaultCountry: "br",
    value,
    countries: defaultCountries,
    onChange: (data) => {
      const sanitized = data.phone.replace(/\D/g, "");
      onChange?.(sanitized);
    },
  });

  const filteredCountries = defaultCountries
    .map(parseCountry)
    .filter((country) => {
      const countryName = getCountryName(country.iso2).toLowerCase();
      return countryName.includes(searchTerm.toLowerCase());
    });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
        setSearchTerm("");
      }
    };

    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpen]);

  const handleMenuKeyDown = (e) => {
    if (/[a-zà-ú]/i.test(e.key) && e.key.length === 1) {
      e.preventDefault();

      if (searchTimeout) {
        clearTimeout(searchTimeout);
      }

      const newSearchTerm = searchTerm + e.key;
      setSearchTerm(newSearchTerm);

      const timeout = setTimeout(() => {
        setSearchTerm("");
      }, 1000);

      setSearchTimeout(timeout);
    }
  };

  const handleCountrySelect = (country) => {
    phoneInput.setCountry(country.iso2);
    setMenuOpen(false);
    setSearchTerm("");
  };

  return (
    <div className="login-phone-input-container" ref={menuRef}>
      <div className="login-input-wrapper">
        <button
          type="button"
          className="login-phone-country-selector"
          onClick={() => setMenuOpen(!menuOpen)}
          onKeyDown={handleMenuKeyDown}
          tabIndex={0}
        >
          <FlagImage iso2={phoneInput.country.iso2} size="20px" />
          <span className="login-phone-country-arrow">▼</span>
        </button>

        <input
          className="login-input login-phone-input-field"
          type="tel"
          inputMode="numeric"
          placeholder={placeholder}
          value={phoneInput.phone}
          onChange={phoneInput.handlePhoneValueChange}
          required={required}
          autoComplete={autoComplete}
          {...rest}
        />
      </div>

      {menuOpen && (
        <div className="login-phone-country-menu">
          <div className="login-phone-country-search">
            <input
              type="text"
              className="login-input"
              placeholder="Buscar país..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              autoFocus
            />
          </div>

          <div className="login-phone-country-list">
            {filteredCountries.map((country) => (
              <button
                key={country.iso2}
                type="button"
                className="login-phone-country-item"
                onClick={() => handleCountrySelect(country)}
              >
                <FlagImage iso2={country.iso2} size="20px" />
                <span className="login-phone-country-name">
                  {getCountryName(country.iso2)}
                </span>
                <span className="login-phone-country-dial">
                  +{country.dialCode}
                </span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginPhoneInput;
